import { i18nFilter } from "app/filters/i18nFilter";
import {
    ChangePercentage,
    DefaultCellRightAlign,
    PercentageBarCellRoundedRight,
    TrafficShare,
    WebsiteTooltipTopCell,
} from "app/components/React/Table/cells";
import { RowSelectionConsumer } from "app/components/React/Table/cells/RowSelection";
import type { IOrderBy } from "app/components/React/Table/Utils/sort";
import type { ISortableColumns } from "app/pages/industry-analysis/market-builder/tabs/industry/table/types";
import {
    DefaultCellHeader,
    DefaultCellHeaderRightAlign,
    DefaultEllipsisHeaderCell,
} from "app/components/React/Table/headerCells";

export const getColumns = (orderBy: IOrderBy<ISortableColumns>) => {
    const i18n = i18nFilter();
    const columns = [
        {
            fixed: true,
            cellComponent: RowSelectionConsumer,
            sortable: false,
            isResizable: false,
            width: 48,
            disableHeaderCellHover: true,
        },
        {
            field: "Domain",
            width: 185,
            sortable: true,
            displayName: i18n("analysis.source.referrals.table.columns.domain.title"),
            tooltip: "widget.table.tooltip.topsites.domain",
            isResizable: true,
            cellComponent: WebsiteTooltipTopCell,
        },
        {
            field: "Share",
            displayName: i18n("common.tables.columns.traffic.share.title"),
            type: "string",
            format: "percentagesign",
            fixed: false,
            sortable: true,
            cellComponent: TrafficShare,
            headerComponent: DefaultCellHeader,
            showTotalCount: false,
            tooltip: i18n("widget.table.tooltip.topsites.share"),
            minWidth: 143,
            isResizable: false,
        },
        {
            field: "AvgMonthVisits",
            displayName: i18n("common.tables.columns.monthly.visits.title"),
            type: "double",
            format: "minVisitsAbbr",
            fixed: false,
            sortable: true,
            headerComponent: DefaultEllipsisHeaderCell,
            cellComponent: DefaultCellRightAlign,
            showTotalCount: false,
            tooltip: i18n("widget.table.tooltip.monthlyvisits"),
            width: 130,
            isResizable: true,
        },
        {
            field: "UniqueUsers",
            displayName: i18n("industry.trends.table.columns.unique.users"),
            type: "double",
            format: "minVisitsAbbr",
            fixed: false,
            sortable: true,
            headerComponent: DefaultEllipsisHeaderCell,
            cellComponent: DefaultCellRightAlign,
            showTotalCount: false,
            tooltip: i18n("industry.trends.table.columns.unique.users.tooltip"),
            width: 155,
            isResizable: true,
        },
        {
            field: "PeriodChange",
            /* eslint-disable no-constant-condition */
            displayName: true
                ? i18n("analysis.source.search.all.table.columns.yearly.change.title")
                : i18n("analysis.source.search.all.table.columns.quarterly.change.title"),
            sortable: true,
            groupable: false,
            cellComponent: ChangePercentage,
            tooltip: true
                ? i18n("analysis.source.search.all.table.columns.yearly.change.tooltip")
                : i18n("analysis.source.search.all.table.columns.quarterly.change.tooltip"),
            width: true ? 118 : 130,
            /* eslint-enable no-constant-condition */
        },
        {
            field: "DesktopMobileShare",
            displayName: i18n("common.tables.columns.desktop.mobile.share.title"),
            sortable: "False",
            groupable: false,
            cellComponent: PercentageBarCellRoundedRight,
            headerComponent: DefaultCellHeaderRightAlign,
            tooltip: "wa.ao.desktopvsmobile.tooltip",
            minWidth: 190,
        },
    ];
    return columns.map((col) => {
        const isSorted = col.field === orderBy.field;
        return {
            ...col,
            visible: true,
            isSorted,
            sortDirection: isSorted ? orderBy.sortDirection : "asc",
        };
    });
};
